import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationService } from './ntofication.service';

@Injectable({
    providedIn: 'root',
})
export class RequestService {

    readonly api: string = environment.api;

    static {console.log(environment.api)};

    constructor(
        @Inject(HttpClient) private http: HttpClient,
        private notificationService: NotificationService
    ) {}

    private buildOptions(params?: any, headers?: any, body?: any): any {
        const options: any = {
            params,
            headers,
            withCredentials: true
        };
        if (body) {
            options.body = body;
        }
        return options;
    }

    public getRequest(relativePath: string, params?: any, headers?: any, alert: boolean = true): Observable<any> {
        return this.http.get<any>(`${this.api}/${relativePath}`, this.buildOptions(params, headers)).pipe(
            tap({
                next: () => {},
                error: (error: any) => this.errorHandler(error)
            })
        );
    }

    public postRequest(relativePath: string, body: any, params?: any, headers?: any, alert: boolean = true): Observable<any> {
        return this.http.post<any>(`${this.api}/${relativePath}`, body, this.buildOptions(params, headers)).pipe(
            tap({
                next: () => {
                    if (alert) this.successHandler();
                },
                error: (error: any) => this.errorHandler(error)
            })
        );
    }

    public putRequest(relativePath: string, body: any, params?: any, headers?: any, alert: boolean = true): Observable<any> {
        return this.http.put<any>(`${this.api}/${relativePath}`, body, this.buildOptions(params, headers)).pipe(
            tap({
                next: () => {
                    if (alert) this.successHandler();
                },
                error: (error: any) => this.errorHandler(error)
            })
        );
    }

    public patchRequest(relativePath: string, body: any, params?: any, headers?: any, alert: boolean = true): Observable<any> {
        return this.http.patch<any>(`${this.api}/${relativePath}`, body, this.buildOptions(params, headers)).pipe(
            tap({
                next: () => {
                    if (alert) this.successHandler();
                },
                error: (error: any) => this.errorHandler(error)
            })
        );
    }

    public deleteRequest(relativePath: string, body: any, alert: boolean = true): Observable<any> {
        return this.http.delete<any>(`${this.api}/${relativePath}`, this.buildOptions(undefined, undefined, body)).pipe(
            tap({
                next: () => {
                    if (alert) this.successHandler();
                },
                error: (error: any) => this.errorHandler(error)
            })
        );
    }

    private successHandler(): void {
        this.notificationService.showNotification('Successo', 'Operazione eseguita con successo', 'success');
    }

    public errorHandler(error: HttpErrorResponse): void {
        this.notificationService.showNotification('Errore', 'Operazione fallita', 'error');
    }
}
